module.exports = __webpack_public_path__ + "static/media/wind-direction-light-ic.423275b9.svg";